import {
  BedDouble, UtensilsCrossed, Compass, Waves, Wine, ShoppingBag,
  Utensils, ChefHat, CalendarDays, Info, Package,
} from "lucide-react";

export const SECTIONS = [
  { type: "accommodation", path: "/dove-dormire", navKey: "nav.sleep", icon: BedDouble, color: "#0F4C83" },
  { type: "restaurant", path: "/ristoranti", navKey: "nav.eat", icon: UtensilsCrossed, color: "#EF7C00" },
  { type: "activity", path: "/esperienze", navKey: "nav.do", icon: Compass, color: "#4A86C5" },
  { type: "sport", path: "/sport", navKey: "nav.sport", icon: Waves, color: "#2E6DA4" },
  { type: "winery", path: "/cantine", navKey: "nav.wine", icon: Wine, color: "#B35900" },
  { type: "product", path: "/prodotti-tipici", navKey: "nav.products", icon: ShoppingBag, color: "#D98E32" },
  { type: "dish", path: "/piatti-tipici", navKey: "nav.dishes", icon: Utensils, color: "#C2410C" },
  { type: "recipe", path: "/ricette", navKey: "nav.recipes", icon: ChefHat, color: "#4A86C5" },
  { type: "event", path: "/eventi", navKey: "nav.events", icon: CalendarDays, color: "#EF7C00" },
  { type: "offer", path: "/pacchetti", navKey: "nav.offers", icon: Package, color: "#0F4C83" },
  { type: "info", path: "/info-utili", navKey: "nav.info", icon: Info, color: "#1E1B16" },
];

export const TYPE_BY_PATH = Object.fromEntries(SECTIONS.map((s) => [s.path, s]));
export const SECTION_BY_TYPE = Object.fromEntries(SECTIONS.map((s) => [s.type, s]));

export const TYPE_COLORS = Object.fromEntries(SECTIONS.map((s) => [s.type, s.color]));
